import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

function EditViewType({ row, open, triggerFetch, closeDialog }) {
  const theme = useTheme();
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [defaultPrice, setDefaultPrice] = useState(0);

  useEffect(() => {
    if (row) {
      setName(row.name);
      setDefaultPrice(row.defaultPrice);
    }
  }, [row]);
  const handleSubmit = async () => {
    // Reset errors
    const newErrors = {};

    // Validation checks
    if (!name.trim()) newErrors.name = "الاسم مطلوب.";
    if (!defaultPrice || defaultPrice <= 0)
      newErrors.defaultPrice =
        "السعر الافتراضي مطلوب ويجب أن يكون أكبر من صفر.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const newType = {
      name: name,
      defaultPrice: Number(defaultPrice),
    };
    if (
      row.name === newType.name &&
      Number(row.defaultPrice) === newType.defaultPrice
    ) {
      toast.error("لم تقم بتعديل شيء!");
      return;
    }
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/viewtype/${row.id}`,
        newType,
        {
          withCredentials: true,
        }
      );
      if (res) {
        closeDialog();
        triggerFetch();
        toast.success("تم تعديل نوع المشاهدات بنجاح");
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  const handleChangePrice = (e) => {
    let newPrice = e.target.value;
    if (newPrice <= 1) {
      setDefaultPrice(1);
    } else {
      setDefaultPrice(newPrice);
    }
  };
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: "12px",
        },
      }}
    >
      <Box sx={{ padding: "24px 24px 0" }}>
        <Typography variant="h5">تعديل نوع المشاهدات</Typography>
      </Box>
      <DialogContent>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="الإسم"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
          />
        </FormControl>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="سعر المشاهدة الإفتراضي"
            type="number"
            value={defaultPrice}
            onChange={handleChangePrice}
            error={!!errors.defaultPrice}
            helperText={errors.defaultPrice}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog()}
          variant="text"
          color={theme.palette.neutral[900]}
        >
          إغلاق
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          تعديل
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditViewType;
